<template>
  <notice-dropdown class="action" :count="unreadCount" :loading="loading">
    <div class="header-title">
      <div>
        <img src="@/assets/notice/notice-icon.png" style="width: 14px;" alt="">
        <span>消息通知</span>
      </div>
      <!-- <CloseOutlined style="color: #999;cursor: pointer;" /> -->
    </div>
    <div class="scroll-list-notice">
      <a-list item-layout="horizontal" :data-source="listData" v-if="!showDetails">
        <template #renderItem="{ item }">
          <a-list-item>
            <a-badge dot v-if="!item.isRead">
              <ExclamationCircleFilled style="color: #FFC565;font-size: 24px;" />
            </a-badge>
            <ExclamationCircleFilled style="color: #CCCCCC;font-size: 24px;" v-else />
            <div class="list-item-title">
              <div class="text-title">{{ item.content.title }}</div>
              <div class="text-time">{{ item.datetime }}</div>
            </div>
            <div class="text-desc" :style="{ color: !item.isRead ? '#1C91F0' : null }" @click="getDetails(item)">详情 ></div>
          </a-list-item>
        </template>
      </a-list>
      <div v-else>
        <div style="height: 300px;margin: 5px; background-color: #fff;">
          <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100%;width:100%">
            <ExclamationCircleFilled style="color: #FFC565; font-size: 48px;top: 40px" />
            <a-list
              item-layout="horizontal"
              :data-source="detailDatas"
              style="width: 100%; margin-top: 20px;"
            >
              <template #renderItem="{ item }">
                <div style="color: #333;font-size: 14px;font-weight: 400;padding: 10px 40px 10px 40px">{{ item }}</div>
              </template>
            </a-list>
          </div>
          <!-- 返回按钮固定在右上角 -->
          <div class="text-desc" @click="showDetails = false;getNoticeData()" style="position: absolute; right: 20px; top: 80px; cursor: pointer;">
            返回 >
          </div>
        </div>
      </div>
    </div>

  </notice-dropdown>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, ref, onBeforeUnmount } from 'vue';
import {getNoticeDetails, getUnreadCount, queryNotices, setNoticeRead} from '@/api/user/notice';
import dayjs from 'dayjs';
import NoticeDropdown from './notice-dropdown.vue';
import NoticeList from './notice-list.vue';
import { message } from 'ant-design-vue';
import { useStore } from 'vuex';
import { SET_INFO } from '@/store/modules/user/mutations';
import { CloseOutlined, ExclamationCircleFilled,  } from '@ant-design/icons-vue';

// 如需要实时更新提醒通知，可以配置 realtime 为 true 打开该轮询，或者自行尝试配置 websocket 功能
// 注意：目前未读数量是通过 currentUSer 接口取回的，如果更改成实时，未读数量也建议更改成独立接口 或者 合并到 getNoticeData 中
const useFetchNotice = (getNoticeData: () => Promise<void>, realtime?: boolean) => {
  let interval: number;
  onMounted(() => {
    getNoticeData();
    if (realtime) {
      interval = setInterval(() => {
        getNoticeData();
      }, 10000);
    }
  });

  onBeforeUnmount(() => {
    clearInterval(interval);
  });
};

export default defineComponent({
  name: 'NoticeIcon',
  // props: {},
  components: {
    NoticeDropdown,
    NoticeList,
    CloseOutlined,
    ExclamationCircleFilled
  },
  emits: [],
  setup() {
    const store = useStore();
    const userInfo = computed(() => store.getters['user/info']);
    const unreadCount = ref<number>(0);
    const loading = ref(true);
    const activeKey = ref('notification');
    const color = {
      todo: '',
      processing: 'blue',
      urgent: 'red',
      doing: 'gold',
    };

    const listData = ref<any[]>([]);
    // 是否展示消息详情
    const showDetails = ref(false);
    // 意见详情
    const detailDatas = ref([]);

    const formatData = (data: any[]) => {

      data.forEach(item => {
          item.datetime = dayjs(item.sendTime).format('YYYY-MM-DD HH:mm:ss');
          // data.content为json字符串，转化为对象
          item.content = JSON.parse(item.content);
      })
      return data;
    };

    const getDetails = (data) => {
      const params = {
        senderName: data.senderName,
        contentIds: data.content.content
      }
      getNoticeDetails(params).then((res) => {
        if (res && res.data) {
          showDetails.value = true;
          detailDatas.value = res.data;
          setNoticeRead(data.id);//标记已读
        }
      });
    };

    const getNoticeData = async () => {
      getUnreadCount().then((res) => {
        unreadCount.value = res.data;
      });
      const params = {
        size: 1000,
        sort: ['isRead,asc','createdDate,desc']
      }
      const res = await queryNotices(params);
      if (res && res.data) {
        listData.value = formatData(res.data);
      }
      loading.value = false;
    };


    useFetchNotice(getNoticeData, true);

    const changeReadState = (clickedItem) => {
      const { id } = clickedItem;
      const index = listData.value.findIndex(item => item.id === id);
      listData.value[index].read = true;
      listData.value = [...listData.value];
      store.commit(`user/${SET_INFO}`, {
        totalCount: listData.value.length,
        unreadCount: listData.value.filter(item => !item.read).length,
      });
      // 你应该通过接口告诉后端更改数据库数据
    };
    const handleViewMore = (key: string) => {
      message.info(`Click on view more ${key}`);
    };
    const handleNoticeClear = (title: string, key: string) => {
      message.success(`Emptied ${title}`);
      listData.value = listData.value.filter(item => item.type !== key);
      store.commit(`user/${SET_INFO}`, {
        totalCount: listData.value.length,
        unreadCount: listData.value.filter(item => !item.read).length,
      });
      // 你应该通过接口告诉后端更改数据库数据
    };
    return {
      activeKey,
      loading,
      color,
      changeReadState,
      handleNoticeClear,
      handleViewMore,
      userInfo,
      listData,
      showDetails,
      getDetails,
      detailDatas,
      getNoticeData,
      unreadCount
    };
  },
});
</script>

<style lang="less" scoped>
.notice-tab :deep(.ant-tabs-nav-list) {
  .ant-tabs-tab {
    flex: 1;
    justify-content: center;
  }
}

.header-title {
  width: 100%;
  height: 48px;
  background-color: #e0ebfd;
  padding: 0 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;

  span {
    font-size: 16px;
    font-weight: 500;
    padding-left: 5px;
    box-sizing: border-box;
    color: #0E66F5;
  }
}

.scroll-list-notice {
  width: 100%;
  background-color: #EAEDF0;
  padding: 10px;
  box-sizing: border-box;
  max-height: 400px;
  overflow: hidden auto;

  .list-item-title {
    width: calc(100% - 100px);

    .text-title {
      color: #333;
      font-size: 14px;
      font-weight: 400;
    }

    .text-time {
      font-size: 12px;
      font-weight: 400;
      color: #999999;
    }


  }

  .text-desc {
    color: #767676;
    font-size: 14px;
    font-weight: 400;
    cursor: pointer;
  }


  :deep(.ant-list-item) {
    margin-bottom: 10px;
    padding: 12px 20px;
    background-color: #fff;
    align-items: flex-start;
  }

  :deep(.ant-list-split .ant-list-item) {
    border: none;
  }
}
</style>
